import "./App.css";
import { Footer } from "./Components/Footer";
import { Navbar } from "./Components/Navbar";
import { MainPage } from "./Pages/MainPage";

// Requesting all please donot modify this code for God sake!!

function App() {
  return (
    <div className="App">
      <Navbar />
      <MainPage />
      <Footer/>
    </div>
  );
}

export default App;
